import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const OuvidoriaRoute = props => {
  const { isOuvidoria } = useContext(UserContext);

  if (isOuvidoria) {
    return <Route {...props} />;
  } else if (!isOuvidoria) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default OuvidoriaRoute;
